module.exports = __webpack_public_path__ + "static/media/section-2-1@3x.4dda305c.png";